let divId;
let variantId;
let variantTitle;
let sectionId;
let lastChangedOptionValue = null;
function createBundle(setDivId, setVariantTitle, setVariantId, setSectionId) {
  divId = setDivId;
  variantId = setVariantId;
  variantTitle = setVariantTitle;
  sectionId = setSectionId;

  // Attach event listeners to bundle options within the specific div
  const container = document.getElementById(divId);
  if (!container) {
    console.error(`[Primal Bundle] No element found with id: ${divId}`);
    return;
  }

  const options = container.querySelectorAll("input");
  options.forEach(function (option) {
    option.addEventListener("change", function () {
      lastChangedOptionValue =
        option.type === "number" ? option.dataset.value : option.value;
      updateHiddenInputValue();
      updateBundleGallery();
    });
  });

  // Ensure the bundle state is correct on initial load
  // addNoneOptions();
  updatePricing();
  updateBundleGallery();
  syncForm();
  updateHiddenInputValue();
  updateSummary();
}
function updateHiddenInputValue() {
  const container = document.querySelector(`#${divId}`);
  let options = container.querySelectorAll(".bundle-options input");
  var values = [];

  options.forEach((option, o) => {
    // Qty selectors
    if (option.getAttribute("type") == "number") {
      for (let i = 0; i < option.value; i++) {
        values.push(option.dataset.value);
      }
    } else if (
      option.checked ||
      option.classList.contains("single-bundle-option")
    ) {
      values.push(option.value);
      // update selected option label
      if (!option.classList.contains("single-bundle-option")) {
        const label = container.querySelector(`label[for="${option.id}"]`);
        if (label) {
          option
            .closest(".bundle-group")
            .querySelector(".bundle-selected-option").innerText =
            label.innerText;
        }
        option
          .closest(".bundle-group")
          .querySelector(".bundle-selected-option").innerText =
          option.labels[0].innerText;
      }
    }
  });

  // Hidden input with each selected products name
  var hiddenInputValue = values.join(" <> ");
  var hiddenInput = container.querySelector(
    'input[name="properties[_bundle_selection]"]',
  );
  if (!hiddenInput) {
    hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "properties[_bundle_selection]";
    container.appendChild(hiddenInput);
  }
  if (!hiddenInput.getAttribute("disabled")) {
    hiddenInput.value = hiddenInputValue;
  }

  syncForm();
  updatePricing();
  updateSummary();
}

// Updates the product gallery with images from all selected bundle options.
// window.bundleMedia is built in bundle-media-gallery which holds each products gallery, which is then built here based off selections
let isInitialGalleryLoad = true;
function updateBundleGallery() {
  const thisIsInitial = isInitialGalleryLoad;
  isInitialGalleryLoad = false;
  //Hide arrows based on image count and viewport
  function updateArrowVisibility() {
    const prevBtn = mediaGallery.querySelector(
      ".thumbnails .swiper-button-prev",
    );
    const nextBtn = mediaGallery.querySelector(
      ".thumbnails .swiper-button-next",
    );
    const galleryList = document.querySelector(
      ".product-gallery .images .swiper-wrapper",
    );
    const slides = galleryList
      ? Array.from(galleryList.querySelectorAll(".swiper-slide")).filter(
          (slide) => slide.offsetParent !== null,
        )
      : [];
    const isMobile = window.innerWidth <= 768;
    let hideArrows = false;
    if (isMobile) {
      hideArrows = slides.length <= 3;
    } else {
      hideArrows = slides.length <= 4;
    }
    if (prevBtn) prevBtn.style.display = hideArrows ? "none" : "";
    if (nextBtn) nextBtn.style.display = hideArrows ? "none" : "";
  }
  // console.log("[Primal Bundle] Updating bundle gallery for div:", divId);
  if (!window.bundleMedia) return;
  const container = document.querySelector(`#${divId}`);
  if (!container) return;

  // Collect all selected bundle option values
  let selectedValues = [];
  let options = container.querySelectorAll(
    ".bundle-options input, .bundle-preselected input",
  );
  options.forEach((option) => {
    if (option.type === "number") {
      let qty = parseInt(option.value, 10);
      for (let i = 0; i < qty; i++) {
        if (option.dataset.value && option.value > 0) {
          selectedValues.push(option.dataset.value);
        }
      }
    } else if (
      option.checked ||
      option.classList.contains("single-bundle-option")
    ) {
      selectedValues.push(option.value);
    }
  });

  // Formatting
  selectedValues = selectedValues.map((v) =>
    v.replace(/['"\s]/g, "-").toLowerCase(),
  );

  // if (window.bundleMedia) {
  //   console.log(
  //     "[Primal Bundle] bundleMedia keys:",
  //     Object.keys(window.bundleMedia)
  //   );
  // }

  // Add slides for selected options, but first remove all previous slides (dynamic and static)
  const galleryList = document.querySelector(
    ".product-gallery .images .swiper-wrapper",
  );
  const thumbnailList = document.querySelector(".thumbnails .swiper-wrapper");
  const galleryId = galleryList?.id || "MediaGallery";

  // Remove all previous slides except those with .product-media (leave essentials-label/static media)
  if (galleryList) {
    Array.from(galleryList.querySelectorAll(".swiper-slide")).forEach((el) => {
      if (!el.classList.contains("product-media")) {
        el.remove();
      }
    });
  }
  if (thumbnailList) {
    Array.from(thumbnailList.querySelectorAll(".swiper-slide")).forEach(
      (el) => {
        if (!el.classList.contains("product-media")) {
          el.remove();
        }
      },
    );
  }

  // Get all media for selected options
  let allMedia = [];
  selectedValues.forEach((val) => {
    if (window.bundleMedia[val]) {
      allMedia = allMedia.concat(window.bundleMedia[val]);
    } else {
      console.warn("[Primal Bundle] No media found for key:", val);
    }
  });

  // Find the next available index for new slides
  let nextIdx = galleryList ? galleryList.children.length : 0;
  let gallerySlides = "";
  let thumbSlides = "";
  allMedia.forEach((media, i) => {
    const thumbSrc = media.poster || media.url;
    gallerySlides += `
      <div class="swiper-slide"
        data-lightbox-type="${media.type || 'image'}"
        data-lightbox-src="${media.url}"
        data-lightbox-alt="${media.alt || ''}"
        data-lightbox-thumb="${thumbSrc}"
      >
        <div class="image-container">
          <img src="${media.url}" alt="${media.alt || ""}" class="component-image half-width" />
        </div>
      </div>
    `;
  });
  allMedia.forEach((media, i) => {
    const thumbMediaId = `${galleryId}-bundle-${i}`;
    // Only image support for thumbnails
    thumbSlides += `
      <button
        class="swiper-slide"
        tabindex="0"
        aria-label="Go to slide ${i + 1}"
        data-target="${thumbMediaId}"
        data-media-position="${nextIdx + i + 1}"
        data-bundle-slide="true"
      >
        <div class="thumbnail-container">
          <img
            id="Thumbnail-${nextIdx + i}"
            src="${media.url}"
            alt="${media.alt || ""}"
            height="84" width="84" loading="lazy"
            class="component-image"
          />
        </div>
      </button>
    `;
  });
  let newBundleSlideEls = [];
  if (galleryList && gallerySlides) {
    // Insert new bundle slides and track their elements
    let tempDiv = document.createElement("div");
    tempDiv.innerHTML = gallerySlides;
    Array.from(tempDiv.children).forEach((li) => {
      newBundleSlideEls.push(li);
    });
    galleryList.insertAdjacentHTML("beforeend", gallerySlides);
    // Move all .swiper-slide.product-media to the end of the wrapper (after new slides are inserted)
    const staticSlides = Array.from(
      galleryList.querySelectorAll(".swiper-slide.product-media"),
    );
    staticSlides.forEach((slide) => galleryList.appendChild(slide));
    // Ensure at least one slide is active after adding new slides
    const slides = galleryList.querySelectorAll(".swiper-slide");
    if (
      slides.length &&
      !galleryList.querySelector(".swiper-slide.is-active")
    ) {
      slides[0].classList.add("is-active");
    }
  }
  if (thumbnailList && thumbSlides) {
    // Capture initial (non-bundle) thumbnails before inserting new bundle ones
    const initialThumbItems = Array.from(
      thumbnailList.querySelectorAll(
        '.swiper-slide:not([data-bundle-slide="true"])',
      ),
    );
    thumbnailList.insertAdjacentHTML("beforeend", thumbSlides);
    // Move initial featured thumbnail(s) to the end so bundle thumbnails appear first
    initialThumbItems.forEach((item) => thumbnailList.appendChild(item));
  }

  // Remove all existing .swiper-notification elements before re-initializing Swiper
  document
    .querySelectorAll(".swiper-notification")
    .forEach((el) => el.remove());

  // Re-init Swiper sliders (match product-gallery-js.liquid)
  // Destroy existing Swipers if present
  if (window.bundleGallerySwiper) {
    window.bundleGallerySwiper.destroy(true, true);
    window.bundleGallerySwiper = null;
  }
  if (window.bundleGalleryThumbs) {
    window.bundleGalleryThumbs.destroy(true, true);
    window.bundleGalleryThumbs = null;
  }

  // Init thumbs Swiper
  window.bundleGalleryThumbs = new Swiper(".product-gallery .thumbnails", {
    spaceBetween: 16,
    slidesPerView: "auto",
    direction: "vertical",
    loop: false,
    watchSlidesProgress: true,
    cssMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Init main gallery Swiper
  window.bundleGallerySwiper = new Swiper(".product-gallery .images ", {
    thumbs: {
      swiper: window.bundleGalleryThumbs,
    },
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: ".swiper-pagination--pdp",
      clickable: true,
      type: "bullets",
    },
    // Optionally add loop: true if needed
    // loop: true,
  });

  // Keyboard support for thumbnails
  var thumbnails = document.querySelectorAll(
    ".product-gallery .thumbnails .swiper-slide",
  );
  window.bundleGalleryThumbs &&
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          var index = Array.prototype.indexOf.call(thumbnails, thumb);
          window.bundleGallerySwiper.slideTo(index);
          thumb.focus();
        }
      });
    });

  // After adding new bundle slides, move to the slide associated with the selected bundle option
  if (newBundleSlideEls.length > 0) {
    setTimeout(() => {
      // Find the index of the bundle slide that matches the last changed option value
      let normalized = lastChangedOptionValue
        ? lastChangedOptionValue.replace(/['"\s]/g, "-").toLowerCase()
        : null;
      let bundleIdx = -1;
      if (normalized) {
        // Find the index in selectedValues that matches the last changed value
        bundleIdx = selectedValues.findIndex((v) => v === normalized);
        if (bundleIdx === -1) bundleIdx = 0;
      } else {
        bundleIdx = 0;
      }
      // Find all slides (including static)
      const slides = Array.from(
        document.querySelectorAll(".product-gallery .images .swiper-slide"),
      );
      // Only consider the newly added bundle slides (not .product-media)
      let bundleSlides = slides.filter(
        (slide) => !slide.classList.contains("product-media"),
      );
      // Clamp bundleIdx to available bundle slides
      if (bundleIdx >= bundleSlides.length) bundleIdx = 0;
      // Get the actual index in the full slides array
      let targetIdx = slides.indexOf(bundleSlides[bundleIdx]);
      if (window.bundleGallerySwiper && targetIdx !== -1) {
        window.bundleGallerySwiper.slideTo(targetIdx);
      }
    }, 50);
  }

  // Attach click listeners to new bundle thumbnails so they update the main gallery
  const mediaGallery = document.querySelector(
    ".product-gallery .images .swiper-wrapper",
  );
  if (
    mediaGallery &&
    mediaGallery.elements &&
    mediaGallery.elements.thumbnails
  ) {
    const newThumbs = mediaGallery.elements.thumbnails.querySelectorAll(
      '[data-bundle-slide="true"]',
    );
    newThumbs.forEach((thumb, i) => {
      const btn = thumb.querySelector("button");
      if (btn) {
        btn.addEventListener("click", function () {
          if (typeof mediaGallery.setActiveMedia === "function") {
            mediaGallery.setActiveMedia(thumb.dataset.target, false);
          }
        });
      }
    });

    // Re-attach prev/next arrow listeners for navigation
    updateArrowVisibility();
    const prevBtn = mediaGallery.querySelector(
      ".thumbnails .swiper-button-prev",
    );
    const nextBtn = mediaGallery.querySelector(
      ".thumbnails .swiper-button-next",
    );
    if (prevBtn && nextBtn) {
      // Remove previous listeners by cloning
      const prevClone = prevBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(prevClone, prevBtn);
      const nextClone = nextBtn.cloneNode(true);
      nextBtn.parentNode.replaceChild(nextClone, nextBtn);

      prevClone.addEventListener("click", (e) => {
        updateArrowVisibility();
        e.preventDefault();
        const galleryList = document.querySelector(
          ".product-gallery .images .swiper-wrapper",
        );
        if (!galleryList) return;
        // Only consider visible slides (not display:none)
        const slides = Array.from(
          galleryList.querySelectorAll(".swiper-slide"),
        ).filter((slide) => slide.offsetParent !== null);
        let idx = slides.findIndex((slide) =>
          slide.classList.contains("is-active"),
        );
        if (idx > 0) {
          const prevSlide = slides[idx - 1];
          if (prevSlide && typeof mediaGallery.setActiveMedia === "function") {
            // console.log(
            //   "[Primal Bundle] Arrow debug: calling setActiveMedia for prev",
            //   prevSlide.dataset.mediaId,
            // );
            mediaGallery.setActiveMedia(prevSlide.dataset.mediaId, false);
          }
        }
      });
      nextClone.addEventListener("click", (e) => {
        updateArrowVisibility();
        e.preventDefault();
        const galleryList = document.querySelector(
          ".product-gallery .images .swiper-wrapper",
        );
        if (!galleryList) return;
        // Only consider visible slides (not display:none)
        const slides = Array.from(
          galleryList.querySelectorAll(".swiper-slide"),
        ).filter((slide) => slide.offsetParent !== null);
        let idx = slides.findIndex((slide) =>
          slide.classList.contains("is-active"),
        );
        if (idx < slides.length - 1) {
          const nextSlide = slides[idx + 1];
          if (nextSlide && typeof mediaGallery.setActiveMedia === "function") {
            // console.log(
            //   "[Primal Bundle] Arrow debug: calling setActiveMedia for next",
            //   nextSlide.dataset.mediaId,
            // );
            mediaGallery.setActiveMedia(nextSlide.dataset.mediaId, false);
          }
        }
      });
    }
  } else {
    console.warn(
      "[Primal Bundle] Could not find media-gallery thumbnails to attach listeners",
    );
  }
}

// This updates the visual pricing based on selected options
function updatePricing() {
  const container = document.querySelector(`#${divId}`);
  // console.log("[Primal Bundle] Updating pricing...", container);
  let total = 0;
  let originalTotal = 0;

  // Get all bundle option inputs
  let options = container.querySelectorAll(".simple-bundles input");
  let selectedKeys = [];

  // Get each selected option and calculate total using bundlePrices
  options.forEach((option) => {
    let key;
    let qty = 1;
    if (option.getAttribute("type") == "number") {
      qty = Number(option.value);
      key = option.dataset.value
        ? option.dataset.value
            .replace(/['"]/g, "")
            .replace(/ /g, "-")
            .toLowerCase()
        : null;
    } else if (
      option.checked ||
      option.classList.contains("single-bundle-option")
    ) {
      key = option.value.replace(/['"]/g, "").replace(/ /g, "-").toLowerCase();
    }
    if (key) {
      selectedKeys.push({ key, qty });
      let bundlePrice = window.bundlePrices[key]?.price;
      if (bundlePrice !== undefined) {
        total += Number(bundlePrice) * qty;
      }
    }
  });

  // Calculate original total using window.productPrices
  if (window.productPrices) {
    selectedKeys.forEach(({ key, qty }) => {
      let price = window.productPrices[key]?.price || 0;
      originalTotal += price * qty;
    });
  }

  // Calculate RRP total
  // if (window.bundleRRP) {
  //   // console.log(
  //   //   "[Primal Bundle] Calculating RRP for selected keys:",
  //   //   selectedKeys
  //   // );
  //   selectedKeys.forEach(({ key, qty }) => {
  //     let rrp = window.bundleRRP[key]?.rrp || 0;
  //     rrpTotal += rrp * qty;
  //   });
  // }

  // Update all RRP displays
  const rrpDivs = document.querySelectorAll(".bundle-rrp");
  rrpDivs.forEach((rrpDiv) => {
    let originalText = originalTotal > 0 ? originalTotal.toFixed(2) : "";
    // Hide RRP if it's the same as the regular price (not on sale)
    if (Math.abs(total - originalTotal) < 0.01 || !originalText) {
      rrpDiv.style.display = "none";
    } else {
      rrpDiv.innerText = "£" + originalText;
      rrpDiv.style.display = "";
    }
  });

  // Update all subtotal displays
  const pricingDivs = document.querySelectorAll(
    `.bundle-sticky-atc--pricing .price-item--regular, .product-pricing-wrapper .price-current`,
  );
  pricingDivs.forEach((pricingDiv) => {
    pricingDiv.innerText = "£" + total.toFixed(2);
    // console.log(
    //   "[Primal Bundle] Updated pricing display (bundlePrices):",
    //   pricingDiv,
    //   total,
    // );
  });
}

// This updates the hidden simple bundles app block selects, syncing them with the custom radio buttons
// By still utilising the app block here, we can also utilise their dynamic pricing calculations
function syncForm() {
  // Find all bundle groups
  var bundleGroups = document.querySelectorAll(".simple-bundles .bundle-group");

  // console.log("[Primal Bundle] Syncing form options...");

  bundleGroups.forEach(function (group, idx) {
    // Get the name of the option (e.g., properties[Bench Option])
    var radios = group.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;
    var optionName = radios[0].getAttribute("name");
    // Find the corresponding select (if any)
    var select = document.querySelector(
      '#simple-bundles-io-options select[name="' + optionName + '"]',
    );
    // console.log("[Primal Bundle] Syncing option:", optionName, select);
    if (!select) return;

    // Sync radio -> select
    // Prevent this handler from running on load by using a flag
    let isInitialSync = true;
    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (isInitialSync) return;
        if (radio.checked) {
          select.value = radio.value;
          // Only fire change event if the value was actually set.
          // Variant values (e.g. "Product - Variant") may not exist as select options,
          // so assigning them fails silently. Dispatching the event with the stale old
          // value would re-apply the previous selection and uncheck this radio.
          if (select.value === radio.value) {
            var event = new Event("change");
            select.dispatchEvent(event);
          }
          // Add 'selected' class to the parent .bundle-option
          radios.forEach(function (r) {
            var optionDiv = r.closest(".bundle-option");
            var label = optionDiv
              ? optionDiv.querySelector("label[for]")
              : null;
            if (optionDiv) {
              if (r.checked) {
                optionDiv.classList.add("selected");
                // Update ARIA for selected
                r.setAttribute("aria-checked", "true");
                r.setAttribute("aria-selected", "true");
                if (label) {
                  label.setAttribute("aria-checked", "true");
                  label.setAttribute("aria-selected", "true");
                }
              } else {
                optionDiv.classList.remove("selected");
                // Remove ARIA from unselected
                r.setAttribute("aria-checked", "false");
                r.setAttribute("aria-selected", "false");
                if (label) {
                  label.setAttribute("aria-checked", "false");
                  label.setAttribute("aria-selected", "false");
                }
              }
            }
          });
        }
      });
    });
    // Set flag to false after initial sync
    setTimeout(() => {
      isInitialSync = false;
    }, 0);

    // Sync select -> radio
    select.addEventListener("change", function () {
      radios.forEach(function (radio) {
        radio.checked = radio.value === select.value;
        var optionDiv = radio.closest(".bundle-option");
        if (optionDiv) {
          if (radio.checked) {
            optionDiv.classList.add("selected");
          } else {
            optionDiv.classList.remove("selected");
          }
        }
      });
    });

    // Initial sync
    var checkedRadio = Array.from(radios).find((r) => r.checked);
    if (checkedRadio) {
      select.value = checkedRadio.value;
      // Only trigger change event if the value was actually set.
      // Variant values (e.g. "Product - Variant") may not exist as select options,
      // so assigning them fails silently. Dispatching with a stale old value would
      // re-apply the previous selection and uncheck the currently-checked radio.
      if (select.value === checkedRadio.value) {
        var event = new Event("change", { bubbles: true });
        select.dispatchEvent(event);
      }
      updatePricing();
    }
  });
}

// Updates #bundle-summary in build-a-box.liquid with a text list of selected options
function updateSummary() {
  const container = document.querySelector(`#${divId}`);
  if (!container) return;

  // Find all selected bundle options
  let selectedOptions = [];

  // Get preselected bundle options first (e.g base rack)
  let preselectedGroups = container.querySelectorAll(".bundle-preselected");
  preselectedGroups.forEach((group) => {
    const input = group.querySelector("input.single-bundle-option");
    if (input) {
      // Find the label (.h5) for this group
      const labelEl = group
        .closest(".bundle-group")
        ?.querySelector(".bundle-group-label .h5");
      const label = labelEl ? labelEl.textContent.trim() : "";
      let value = input.dataset.title || input.title || input.value;
      selectedOptions.push({ label, value });
    }
  });

  // Bundle selections
  let bundleGroups = container.querySelectorAll(".bundle-group");
  bundleGroups.forEach((group) => {
    const labelEl = group.querySelector(".bundle-group-label .h5");
    const label = labelEl ? labelEl.textContent.trim() : "";
    // Check for radio inputs
    let radios = group.querySelectorAll('.bundle-options input[type="radio"]');
    let checkedRadio = Array.from(radios).find((r) => r.checked);
    if (checkedRadio) {
      let value =
        checkedRadio.dataset.title || checkedRadio.title || checkedRadio.value;
      selectedOptions.push({ label, value });
    }
    let qtyInputs = group.querySelectorAll(
      '.bundle-options input[type="number"]',
    );
    qtyInputs.forEach((input) => {
      let qty = parseInt(input.value, 10);
      if (qty > 0 && input.dataset.title) {
        let value = input.dataset.title + (qty > 1 ? ` x${qty}` : "");
        selectedOptions.push({ label, value });
      }
    });
  });

  // Build the summary list
  const bundleSummary = document.getElementById("bundle-summary");
  if (bundleSummary) {
    let bundleList = bundleSummary.querySelector(".bundle-summary-list");
    if (!bundleList) {
      bundleList = document.createElement("div");
      bundleList.className = "bundle-summary-list";
      bundleSummary.appendChild(bundleList);
    }
    if (selectedOptions.length) {
      bundleList.innerHTML =
        "<ul>" +
        selectedOptions
          .map((opt) => `<li><strong>${opt.label}</strong> ${opt.value}</li>`)
          .join("") +
        "</ul>";
    } else {
      bundleList.innerHTML = "";
    }
  }
}

// "Get a custom quote" pre-filled body text of product info
function handleCustomOrderClick(e) {
  if (e) e.preventDefault();
  const allGroups = document.querySelectorAll(".bundle-group");
  let found = false;
  let message = "";
  // Get the main bundle product title from the page to include
  let bundleProductTitle = "";
  const h1 = document.querySelector("h1");
  if (h1) {
    bundleProductTitle = h1.textContent.trim();
  } else {
    const titleEl = document.querySelector(".product__title");
    if (titleEl) bundleProductTitle = titleEl.textContent.trim();
  }
  // Gather the selected option of each bundle group
  allGroups.forEach((group) => {
    let selectedInput = group.querySelector(
      'input[type="radio"]:checked, input.single-bundle-option',
    );
    // Find the label for this group
    let groupLabel = "";
    const labelEl = group.querySelector(
      ".bundle-group-label .h5, .bundle-group-label span.h5",
    );
    if (labelEl) groupLabel = labelEl.textContent.trim();
    if (selectedInput && selectedInput.value && selectedInput.dataset.variant) {
      // Build message
      // Message comes through as something like: Rack Option: Primal Personal Series Plate Loading Multi Rack System - Multi Rack System with Weight Stacks (Variant ID: 45289364684954)
      found = true;
      message += `- ${groupLabel} ${selectedInput.value} (Variant ID: ${selectedInput.dataset.variant})\n`;
    }
  });
  if (!found) {
    message = "No selected products found in bundle groups.";
  }
  // Open the popup form
  let popupForm = document.querySelector(".quote-bulk-order-block .hbspt-form");
  if (popupForm) {
    popupForm.classList.add("active");

    // Add a short delay before adding 'overflow-hidden' to body
    setTimeout(function () {
      document.body.classList.add("overflow-hidden");
    }, 100);
    // Find the textarea for the message
    let textarea = popupForm.querySelector(
      "textarea[name='message'], textarea",
    );
    if (textarea) {
      textarea.value = `I'd like a quote for ${bundleProductTitle ? bundleProductTitle : "this bundle"}:\n${message}`;
    }
  }
}

document
  .querySelectorAll(
    ".product-form__buttons .button--custom-order, .quote-bulk-order-block .button--custom-order",
  )
  .forEach(function (btn) {
    btn.addEventListener("click", handleCustomOrderClick);
  });

// On DOMContentLoaded, ensure all bundles are initialized to correct state
document.addEventListener("DOMContentLoaded", function () {
  // If createBundle is called elsewhere, this is a safeguard for any missed initial state
  // If you have multiple bundles, you may want to call updateHiddenInputValue for each
  const bundleDivs = document.querySelectorAll('[id^="bundle-"]');
  bundleDivs.forEach(function (div) {
    // Only update if the div contains bundle options
    if (div.querySelector(".bundle-options input")) {
      // Try to update hidden input and summary for each bundle
      divId = div.id;
      updateHiddenInputValue();
      updateSummary();
    }
  });
});

// Accessibility: Allow labels to be focused and toggled via keyboard for bundle options
document
  .querySelectorAll(".bundle-options label[for]")
  .forEach(function (label) {
    label.setAttribute("tabindex", "0");
    label.setAttribute("role", "radio");
    // Set initial aria-checked and aria-selected based on input
    var inputId = label.getAttribute("for");
    var input = document.getElementById(inputId);
    if (input) {
      label.setAttribute("aria-checked", input.checked ? "true" : "false");
      label.setAttribute("aria-selected", input.checked ? "true" : "false");
    }
    label.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") {
        var inputId = label.getAttribute("for");
        var input = document.getElementById(inputId);
        if (input && !input.disabled) {
          input.checked = true;
          input.focus();
          input.dispatchEvent(new Event("change", { bubbles: true }));
          e.preventDefault();
        }
      }
    });
  });

syncForm();

// Resync bundle options on ATC as fallback
document.querySelectorAll("form").forEach(function (form) {
  const atcButtons = form.querySelectorAll(".product-form__submit");
  atcButtons.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      syncForm();
    });
  });
});
